import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import {getToken} from '@/utils/auth'
import store from '../store'
import router from '../router'


// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_URL, // api的base_url
  timeout: 15000,                // 请求超时时间2
  withCredentials: true
})
// request拦截器
service.interceptors.request.use(config => {
  //store.dispatch('axiosLoadings', true); // loading
  return config
}, error => {
  // Do something with request error
  console.error(error) // for debug
  Promise.reject(error)
})
// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code == '0000') {
      //store.dispatch('axiosLoadings', false); // loading
      return res;
    }
    if (res.code == '100') {
      return res.returnData;
    } else if (res.code == "10010") {
      //store.dispatch('axiosLoadings', false); // loading
      Message({
        showClose: true,
        message: res.msg,
        type: 'error',
        duration: 500,
        onClose: () => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        }
      });
      return Promise.reject("未登录")
    } else {
      //store.dispatch('axiosLoadings', false); // loading
      Message({
        message: res.msg,
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject(res)
    }
  },
  error => {
    console.error('err' + error)// for debug
    //store.dispatch('axiosLoadings', false) // loading
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)
export default service




// WEBPACK FOOTER //
// ./src/utils/api.js